module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/izvestaji/izvestaj-za-ofps/izvestaj-za-ofps.component.scss
// module id = ./src/app/pages/izvestaji/izvestaj-za-ofps/izvestaj-za-ofps.component.scss
// module chunks = main